import { c as _c } from "react/compiler-runtime";
import type { ApiDropPollOption } from "@/generated/models/ApiDropPollOption";
import { CheckIcon } from "@heroicons/react/24/outline";
export function PollVoteOption(t0) {
  const $ = _c(28);
  const {
    option,
    checked,
    multichoice,
    groupName,
    disabled,
    onChange
  } = t0;
  const indicatorShapeClass = multichoice ? "tw-rounded" : "tw-rounded-full";
  const rowStateClass = checked ? "tw-border-iron-600 tw-bg-iron-800 tw-shadow-[0_0_15px_rgba(245,245,245,0.04)]" : "tw-border-iron-700 tw-bg-iron-800/60 desktop-hover:hover:tw-border-iron-600 desktop-hover:hover:tw-bg-iron-800/80";
  const indicatorStateClass = checked ? "tw-scale-110 tw-border-iron-50 tw-bg-iron-50 desktop-hover:group-hover/vote:tw-scale-100 desktop-hover:group-hover/vote:tw-border-iron-200 desktop-hover:group-hover/vote:tw-bg-iron-200" : "tw-border-iron-600 tw-bg-iron-900/50 desktop-hover:group-hover/vote:tw-border-iron-400";
  const selectionFillClass = checked ? "tw-scale-x-100 tw-opacity-100" : "tw-scale-x-0 tw-opacity-0";
  const t1 = `tw-group/vote tw-relative tw-flex tw-min-h-11 tw-transform-gpu tw-cursor-pointer tw-items-start tw-gap-2.5 tw-overflow-hidden tw-rounded-lg tw-border tw-border-solid tw-px-3.5 tw-py-3 tw-transition-all tw-duration-300 active:tw-scale-[0.99] ${rowStateClass} ${disabled ? "tw-cursor-not-allowed tw-opacity-60" : ""}`;
  let t2;
  if ($[0] !== multichoice || $[1] !== selectionFillClass) {
    t2 = !multichoice && <span className={`tw-pointer-events-none tw-absolute tw-inset-y-0 tw-left-0 tw-w-full tw-origin-left tw-transform-gpu tw-bg-iron-700 tw-transition-[transform,opacity] tw-duration-300 tw-ease-out ${selectionFillClass}`} aria-hidden="true" />;
    $[0] = multichoice;
    $[1] = selectionFillClass;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = multichoice ? "checkbox" : "radio";
  let t4;
  if ($[3] !== onChange || $[4] !== option.option_no) {
    t4 = () => onChange(option.option_no);
    $[3] = onChange;
    $[4] = option.option_no;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== checked || $[7] !== disabled || $[8] !== groupName || $[9] !== option.option_string || $[10] !== t3 || $[11] !== t4) {
    t5 = <input type={t3} name={groupName} checked={checked} disabled={disabled} aria-label={option.option_string} onClick={_temp} onChange={t4} className="tw-peer tw-sr-only" />;
    $[6] = checked;
    $[7] = disabled;
    $[8] = groupName;
    $[9] = option.option_string;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const t6 = `tw-relative tw-z-10 tw-mt-0.5 tw-flex tw-size-4 tw-shrink-0 tw-items-center tw-justify-center tw-border tw-border-solid tw-transition-all tw-duration-300 peer-focus-visible:tw-ring-2 peer-focus-visible:tw-ring-white/30 ${indicatorShapeClass} ${indicatorStateClass}`;
  let t7;
  if ($[13] !== checked || $[14] !== multichoice) {
    t7 = multichoice ? <CheckIcon className={`tw-size-2.5 tw-text-iron-950 tw-transition-all tw-duration-200 ${checked ? "tw-scale-100 tw-opacity-100" : "tw-scale-50 tw-opacity-0"}`} strokeWidth={3} /> : <span className={`tw-size-1.5 tw-rounded-full tw-bg-iron-950 tw-transition-all tw-duration-200 ${checked ? "tw-scale-100 tw-opacity-100" : "tw-scale-0 tw-opacity-0"}`} />;
    $[13] = checked;
    $[14] = multichoice;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6 || $[17] !== t7) {
    t8 = <span className={t6} aria-hidden="true">{t7}</span>;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const t9 = `tw-relative tw-z-10 tw-min-w-0 tw-break-words tw-text-sm tw-leading-5 tw-transition-colors tw-duration-300 ${checked ? "tw-font-medium tw-text-iron-50" : "tw-font-medium tw-text-iron-100 desktop-hover:group-hover/vote:tw-text-iron-50"}`;
  let t10;
  if ($[19] !== option.option_string || $[20] !== t9) {
    t10 = <span className={t9}>{option.option_string}</span>;
    $[19] = option.option_string;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t1 || $[23] !== t10 || $[24] !== t2 || $[25] !== t5 || $[26] !== t8) {
    t11 = <label className={t1}>{t2}{t5}{t8}{t10}</label>;
    $[22] = t1;
    $[23] = t10;
    $[24] = t2;
    $[25] = t5;
    $[26] = t8;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  return t11;
}
function _temp(event) {
  return event.stopPropagation();
}